import { HTMLAttributes } from 'react';
import { linkStyles } from './Link';
import { VariantProps } from 'class-variance-authority';
import { textVariants } from './Text';
import { cn } from '../utils';

interface TextWithLinksProps
  extends Omit<HTMLAttributes<HTMLParagraphElement>, 'color'>,
    VariantProps<typeof textVariants> {
  text: string;
  linkVariant?: 'blue' | 'black' | 'white';
  linkTarget?: '_self' | '_blank' | '_parent' | '_top';
}

export const TextWithLinks: React.FC<TextWithLinksProps> = ({
  text,
  color,
  font,
  family,
  linkVariant = 'blue',
  linkTarget = '_self',
  ...props
}: TextWithLinksProps) => {
  const renderTextWithLinks = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) =>
      urlRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target={linkTarget}
          className={cn(linkStyles({ variant: linkVariant }))}
        >
          {part}
        </a>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  };

  return (
    <p
      className={cn(textVariants({ color, font, family }), props.className)}
      style={{ wordBreak: 'break-word' }}
    >
      {renderTextWithLinks(text)}
    </p>
  );
};
